import React, { useState, useRef } from "react";
import { Container } from "./common/Container";
import emailjs from "@emailjs/browser";
import { ClockIcon, MapPinIcon, PhoneIcon } from "@heroicons/react/24/outline";
import ContactImg from "../assets/contact.png";
import DemoImg from "../assets/demo.avif";

const Contact = () => {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ success: false, message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus({ success: false, message: "" });

    emailjs
      .sendForm(
        "service_gct6mw6", // Replace with your EmailJS service ID
        "template_w2rfcxl", // Replace with your EmailJS template ID
        form.current,
        "VIjfhcyEQhAe8UqX2", // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          setStatus({ success: true, message: "Message sent successfully!" });
          form.current.reset();
          setIsLoading(false);
        },
        (error) => {
          setStatus({
            success: false,
            message: "Failed to send message. Please try again.",
          });
          setIsLoading(false);
        },
      );
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `linear-gradient(20deg, #082635, rgba(0,0,0,0.1)), url(${DemoImg})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
        className="pb-24 pt-40 md:pb-52 md:pt-52"
      >
        <Container>
          <h1 className="mt-4 text-xl font-bold text-white sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
            Reach Out | Let’s Connect!
          </h1>
        </Container>
      </div>
      <Container>
        <div className="head mb-[50px] pt-[70px] md:mb-20 lg:pt-[120px]">
          <h2 className="mb-4 text-[24px] font-bold leading-snug text-custom-dark-blue sm:text-[36px] lg:text-[40px] xl:text-[44px] 2xl:text-[48px]">
            Feel free to{" "}
            <span className="relative text-custom-orange">get in touch!</span>
          </h2>
          <p className="max-w-[800px] text-sm text-gray-600 md:text-base">
            Let’s talk about a project, collaboration or an idea you may have
          </p>

          <div className="mt-12 flex flex-wrap justify-between">
            <div className="flex w-full items-center sm:w-[48%] lg:w-[30%]">
              <span className="mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-lg border border-[#d4d4d491] bg-gradient-box shadow-custom-box md:h-[90px] md:w-[90px]">
                <MapPinIcon className="w-6 text-custom-orange md:w-10" />
              </span>
              <div className="flex-1">
                <h4 className="fontSuse mb-2 text-sm font-semibold uppercase text-custom-dark-blue">
                  Office Address
                </h4>
                <a href="#" className="block text-sm text-gray-600">
                  Lower chitral, Pakistan
                </a>
              </div>
            </div>

            <div className="mb-4 flex w-full items-center sm:mb-0 sm:w-[48%] lg:w-[30%]">
              <span className="mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-lg border border-[#d4d4d491] bg-gradient-box shadow-custom-box md:h-[90px] md:w-[90px]">
                <PhoneIcon className="w-6 text-custom-orange md:w-10" />
              </span>
              <div className="flex-1">
                <h4 className="fontSuse mb-2 text-sm font-semibold uppercase text-custom-dark-blue">
                  Contact Us
                </h4>
                <a
                  href="mailto:hubbeconnect7@gmail.com"
                  className="mb-1 block text-sm text-gray-600"
                >
                  hubbeconnect7@gmail.com
                </a>
                <a
                  href="tel:+923400180008"
                  className="block text-sm text-gray-600"
                >
                  (+92) 3400180008
                </a>
              </div>
            </div>

            <div className="mb-4 flex w-full items-center sm:mb-6 lg:mb-0 lg:w-[40%]">
              <span className="mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-lg border border-[#d4d4d491] bg-gradient-box shadow-custom-box md:h-[90px] md:w-[90px]">
                <ClockIcon className="w-6 text-custom-orange md:w-10" />
              </span>
              <div className="flex-1">
                <h4 className="fontSuse mb-2 text-sm font-semibold uppercase text-custom-dark-blue">
                  Working Hours
                </h4>
                <div className="text-sm text-gray-600">
                  <span className="mb-1 block">
                    Weekdays 8:00 AM - 10:00 PM
                  </span>
                  <span className="block">Closed on Weekends</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-[70px] flex items-center rounded-2xl border border-[#d4d4d491] bg-gradient-box p-4 shadow-custom-box sm:p-6 md:p-8 lg:mb-[120px]">
          <form
            ref={form}
            onSubmit={handleSubmit}
            className="w-full md:mr-4 md:w-[60%] lg:w-[500px] 2xl:mr-20"
          >
            <div className="flex flex-col gap-x-4 sm:flex-row sm:gap-x-6">
              <input
                type="text"
                name="user_name"
                placeholder="Name"
                required
                className="fontSuse mb-4 w-full rounded-md bg-white px-4 py-3 text-sm text-custom-black outline-none ring-1 ring-inset ring-gray-300 transition duration-300 placeholder:text-xs placeholder:font-medium placeholder:uppercase placeholder:tracking-wider placeholder:text-gray-500 focus:ring-2 focus:ring-custom-orange sm:mb-6"
              />
              <input
                type="tel"
                name="user_phone"
                placeholder="Phone"
                className="fontSuse mb-4 w-full rounded-md bg-white px-4 py-3 text-sm text-custom-black outline-none ring-1 ring-inset ring-gray-300 transition duration-300 placeholder:text-xs placeholder:font-medium placeholder:uppercase placeholder:tracking-wider placeholder:text-gray-500 focus:ring-2 focus:ring-custom-orange sm:mb-6"
              />
            </div>

            <input
              type="email"
              name="user_email"
              placeholder="Email"
              required
              className="fontSuse mb-4 w-full rounded-md bg-white px-4 py-3 text-sm text-custom-black outline-none ring-1 ring-inset ring-gray-300 transition duration-300 placeholder:text-xs placeholder:font-medium placeholder:uppercase placeholder:tracking-wider placeholder:text-gray-500 focus:ring-2 focus:ring-custom-orange sm:mb-6"
            />

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              required
              className="fontSuse mb-4 w-full rounded-md bg-white px-4 py-3 text-sm text-custom-black outline-none ring-1 ring-inset ring-gray-300 transition duration-300 placeholder:text-xs placeholder:font-medium placeholder:uppercase placeholder:tracking-wider placeholder:text-gray-500 focus:ring-2 focus:ring-custom-orange sm:mb-6"
            />

            <textarea
              name="message"
              placeholder="Message"
              required
              className="fontSuse mb-4 min-h-[100px] w-full resize-none rounded-md bg-white px-4 py-3 text-sm text-custom-black outline-none ring-1 ring-inset ring-gray-300 transition duration-300 placeholder:text-xs placeholder:font-medium placeholder:uppercase placeholder:tracking-wider placeholder:text-gray-500 focus:ring-2 focus:ring-custom-orange sm:mb-6"
            ></textarea>

            <button
              type="submit"
              disabled={isLoading}
              className="fontSuse w-full rounded-md bg-custom-orange px-6 py-3 text-sm font-semibold uppercase tracking-wider text-white transition-colors hover:bg-orange-600 disabled:opacity-50"
            >
              {isLoading ? "Sending..." : "Send Message"}
            </button>

            {status.message && (
              <div
                className={`mt-4 text-sm ${status.success ? "text-green-600" : "text-red-600"}`}
              >
                {status.message}
              </div>
            )}
          </form>

          <div className="hidden flex-1 md:block">
            <div className="mx-auto w-full xl:w-[70%]">
              <img src={ContactImg} alt="contact us" width={"100%"} />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Contact;
